import { pipe } from 'ramda';
import { COMPONENT_SETTING_TYPES, COMPONENT_SETTING_VIEWS } from '../../../constants';
import { createSelectOptionByValue } from '../../../utils/createSelectOptionByValue';
import { assocSettings, BASIC_PROPS_TOOLTIP, BASIC_STYLE_TOOLTIP, disableRadioOptions, disableSpacingPaddings, DISPLAY_OPTION_VALUES, getBasicPropsSettings, NS_ID, pickSettings, trimDividers, } from '../../common';
import { getCommonActionListSettings, getCommonActionSettings, getDivider, getPropertySections, getStyleSections, } from '../../common/settings';
export const getBuilderComponentsDatePickerSettings = (prefixPath = []) => ({
    properties: [
        {
            type: COMPONENT_SETTING_TYPES.rootSection,
            name: NS_ID.properties.root,
            children: [
                {
                    type: COMPONENT_SETTING_TYPES.section,
                    title: 'Basic',
                    name: NS_ID.properties.basic,
                    titleDescription: BASIC_PROPS_TOOLTIP,
                    children: [
                        {
                            componentView: COMPONENT_SETTING_VIEWS.text,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'value'],
                            label: 'Value',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.text,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'label'],
                            label: 'Label',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.text,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'initialFocusedDate'],
                            label: 'Initial Date',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.text,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'inputFormat'],
                            label: 'Format',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'readOnly'],
                            label: 'Read Only',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'disabled'],
                            label: 'Disabled',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'strictCompareDates'],
                            label: 'Strict Compare Dates',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.select,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'openTo'],
                            label: 'Open To',
                            options: ['day', 'year', 'month'].map(createSelectOptionByValue),
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'animateYearScrolling'],
                            label: 'Animate Year Scrolling',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'autoOk'],
                            label: 'Auto Ok',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'disableFuture'],
                            label: 'Disable Future',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'disablePast'],
                            label: 'Disable Past',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'disableToolbar'],
                            label: 'Disable Toolbar',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.text,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'emptyLabel'],
                            label: 'Empty Label',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.text,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'invalidLabel'],
                            label: 'Invalid Label',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.text,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'mask'],
                            label: 'Mask',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.text,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'maskChar'],
                            label: 'Mask Char',
                        },
                    ],
                },
                getDivider(),
                ...getBasicPropsSettings(),
                getDivider(),
                ...getPropertySections(),
            ],
        },
    ],
    style: [
        {
            type: COMPONENT_SETTING_TYPES.rootSection,
            name: NS_ID.style.root,
            children: [
                {
                    type: COMPONENT_SETTING_TYPES.section,
                    title: 'Basic',
                    titleDescription: BASIC_STYLE_TOOLTIP,
                    name: NS_ID.style.basic,
                    children: [
                        {
                            componentView: COMPONENT_SETTING_VIEWS.select,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: [...prefixPath, 'inputVariant'],
                            label: 'Input Variant',
                            options: ['standard', 'outlined', 'filled'].map(createSelectOptionByValue),
                        },
                    ],
                },
                getDivider(),
                ...pipe(assocSettings([NS_ID.style.spacing.root, NS_ID.style.spacing.editor], disableSpacingPaddings), assocSettings([NS_ID.style.display.root, NS_ID.style.display.display], disableRadioOptions([DISPLAY_OPTION_VALUES.grid, DISPLAY_OPTION_VALUES.flex])), pickSettings([
                    [NS_ID.style.spacing.root],
                    [NS_ID.style.display.root],
                    [NS_ID.style.flexChild.root],
                    [NS_ID.style.gridChild.root],
                    [NS_ID.style.font.root, NS_ID.style.font.color],
                    [NS_ID.style.font.root, NS_ID.style.font.fontFamily],
                    [NS_ID.style.font.root, NS_ID.style.font.fontSize],
                    [NS_ID.style.font.root, NS_ID.style.font.fontWeight],
                    [NS_ID.style.font.root, NS_ID.style.font.textAlign],
                    [NS_ID.style.font.root, NS_ID.style.font.textDecoration],
                    [NS_ID.style.font.root, NS_ID.style.font.textTransform],
                    [NS_ID.style.size.root, NS_ID.style.size.width],
                    [NS_ID.style.size.root, NS_ID.style.size.height],
                    [NS_ID.style.background.root],
                    [NS_ID.style.border.root],
                    [NS_ID.style.css.root],
                ]), trimDividers)(getStyleSections(prefixPath)),
            ],
        },
    ],
    events: [
        {
            type: COMPONENT_SETTING_TYPES.rootSection,
            name: NS_ID.events.root,
            children: [
                {
                    type: COMPONENT_SETTING_TYPES.eventsSection,
                    name: NS_ID.events.events,
                    title: 'Events',
                    children: [
                        {
                            type: COMPONENT_SETTING_TYPES.action,
                            name: 'onChangeAction',
                            label: 'On Change',
                            keyPath: [...prefixPath, 'onChange'],
                            children: getCommonActionSettings([...prefixPath, 'onChange']),
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.action,
                            name: 'onAcceptAction',
                            label: 'On Accept',
                            keyPath: [...prefixPath, 'onAccept'],
                            children: getCommonActionSettings([...prefixPath, 'onAccept']),
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.action,
                            name: 'onCloseAction',
                            label: 'On Close',
                            keyPath: [...prefixPath, 'onClose'],
                            children: getCommonActionSettings([...prefixPath, 'onClose']),
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.action,
                            name: 'onErrorAction',
                            label: 'On Error',
                            keyPath: [...prefixPath, 'onError'],
                            children: getCommonActionSettings([...prefixPath, 'onError']),
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.action,
                            name: 'onMonthChangeAction',
                            label: 'On Month Change',
                            keyPath: [...prefixPath, 'onMonthChange'],
                            children: getCommonActionSettings([...prefixPath, 'onMonthChange']),
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.action,
                            name: 'onYearChangeAction',
                            label: 'On Year Change',
                            keyPath: [...prefixPath, 'onYearChange'],
                            children: getCommonActionSettings([...prefixPath, 'onYearChange']),
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.action,
                            name: 'onOpenAction',
                            label: 'On Open',
                            keyPath: [...prefixPath, 'onOpen'],
                            children: getCommonActionSettings([...prefixPath, 'onOpen']),
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.action,
                            name: 'rifmFormatterAction',
                            label: 'Rifm Formatter',
                            keyPath: [...prefixPath, 'rifmFormatter'],
                            children: getCommonActionSettings([...prefixPath, 'rifmFormatter']),
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.action,
                            name: 'shouldDisableDateAction',
                            label: 'Should Disable Date',
                            keyPath: [...prefixPath, 'shouldDisableDate'],
                            children: getCommonActionSettings([...prefixPath, 'shouldDisableDate']),
                        },
                        ...getCommonActionListSettings(),
                    ],
                },
            ],
        },
    ],
});
export const BuilderComponentsDatePickerSettings = getBuilderComponentsDatePickerSettings();
